import { useGetInvoicesQuery } from "@/services/tax/tax-workflow";
import { ContentContainer, PageLayout, PageTitle } from "components/layout";
import { handeOrderBy } from "@/utils/pagination";
import { useFilterState } from "./filter/hooks/filterState";
import { DataTable } from "./components/table/data-table";
import { getColumns } from "./components/table/columns";
import { SelectedItemsProvider } from "./context/selected-items-context";

const TaxWorkflowContent = () => {
  const { filters } = useFilterState();
  const orderBy = handeOrderBy(filters.order);

  const {
    data: invoiceData,
    refetch,
    isLoading,
  } = useGetInvoicesQuery({
    search: filters.search,
    orderBy: JSON.stringify(orderBy),
    page: filters.meta.page,
    perPage: filters.meta.perPage,
    state: filters.state || "",
    from_date: filters.from_date || "",
    to_date: filters.to_date || "",
    is_payed: filters.is_payed || "",
    generated_gnre: filters.generated_gnre || "",
    has_ncm_assigned: filters.has_ncm_assigned || "",
  });

  const { data = [], meta } = invoiceData ?? { data: [], meta: undefined };

  return (
    <DataTable
      columns={getColumns()}
      data={data}
      meta={meta}
      refetch={refetch}
      isLoading={isLoading}
    />
  );
};

const TaxWorkflow = () => {
  return (
    <PageLayout>
      <PageTitle
        title="Controle Fiscal"
        description="Cuide de todo o processo de geração de guias GNRE e NFF por aqui."
      />
      <ContentContainer>
        <SelectedItemsProvider>
          <TaxWorkflowContent />
        </SelectedItemsProvider>
      </ContentContainer>
    </PageLayout>
  );
};

export default TaxWorkflow;
